import React from "react";
import useAuthStore from "../Auth/useAuthStore";

const HandleLogout = () => {
    useAuthStore.getState().signOut();
};

const WhiltelistedFileTypesForImages = (fileType) => {
    if (fileType === "image/jpeg" || fileType === "image/jpg" || fileType === "image/png" || fileType === "image/tiff") {
        return true
    }
    return false
}

const WhiltelistedFileTypesForDocuments = (fileType) => {
    if (fileType === "application/pdf") {
        return true
    }
    return false
}

export default {HandleLogout, WhiltelistedFileTypes: WhiltelistedFileTypesForImages, WhiltelistedFileTypesForDocuments};
